import styled from 'styled-components';

import { Cost } from '@r1-frontend/ui-react/components/costs';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';

export const EquipmentControlsComponent = styled(ListContainer)`
    align-items: center;
    
    ${Cost} {
        width: 100%;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${Paragraph5} {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        ${Cost} {
            width: auto;
        }
    }
`;
